<div class="@disableAnimations">
  @if (type() === 'date') {
    <mat-form-field class="w-full">
      <mat-label>{{ label() }}</mat-label>

      <input
        matInput
        [formControl]="control()"
        [matDatepicker]="picker"
      />

      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      >
      </mat-datepicker-toggle>

      <mat-datepicker #picker></mat-datepicker>

      @if (control().invalid) {
        <mat-error>{{ errorMsg() }}</mat-error>
      }
    </mat-form-field>
  } @else if (type() === 'time') {
    <mat-form-field class="w-full">
      <mat-label>{{ label() }}</mat-label>

      <input
        matInput
        [formControl]="control()"
        [matTimepicker]="picker"
      />

      <mat-timepicker-toggle
        matIconSuffix
        [for]="picker"
      />

      <mat-timepicker #picker />
    </mat-form-field>
  } @else {
    <mat-form-field class="w-full">
      <mat-label>{{ label() }}</mat-label>

      <input
        matInput
        [disabledInteractive]="false"
        [type]="type()"
        [formControl]="control()"
        [placeholder]="placeholder()"
      />

      @if (control().invalid) {
        <mat-error>{{ errorMsg() }}</mat-error>
      }
    </mat-form-field>
  }
</div>
